import React from 'react';
import { ALERT_STYLES } from '../styles/alertPalette';

export default function GatingModal({ open, onClose, onSignup, onLogin }) {
  if (!open) return null;
  return (
    <div role="dialog" aria-modal="true" aria-label="Unlock full video" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'grid', placeItems: 'center', zIndex: 1000 }}>
      <div style={{ width: '90%', maxWidth: 420, background: ALERT_STYLES.warning.background, border: ALERT_STYLES.warning.border, borderRadius: 12, padding: 16, color: '#e5e7eb', boxShadow: `${ALERT_STYLES.warning.boxShadow}, 0 10px 30px rgba(0,0,0,0.5)` }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontWeight: 700 }}>Unlock full video with credits</h3>
          <button onClick={onClose} aria-label="Close" style={{ background: 'transparent', color: '#9ca3af', border: 0, fontSize: 18, cursor: 'pointer' }}>×</button>
        </div>
        <p style={{ marginTop: 8, color: '#9ca3af' }}>Sign up or log in to purchase credits and render your full video.</p>
        <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
          <button onClick={onSignup} style={{ background: '#00BBF9', color: '#0b0b0e', border: 0, padding: '10px 12px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>Sign Up</button>
          <button onClick={onLogin} style={{ background: '#ff5a1f', color: '#fff', border: 0, padding: '10px 12px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>Log In</button>
        </div>
      </div>
    </div>
  );
}
